import UTFGridClass, * as UTFGridModule from './../../node_modules/ol/source/UTFGrid.js';

class UTFGrid extends UTFGridClass {
    constructor(options = {}) {
        options = options || {}
        super(options);
    }
}

// Copy all named exports as static methods
for (const key in UTFGridModule) {
    if (key !== "default") {
        UTFGrid[key] = UTFGridModule[key];
    }
}

export default UTFGrid;

// Re-export ALL named exports from OL
export * from './../../node_modules/ol/source/UTFGrid.js';